import { render, staticRenderFns } from "./fiche-de-presence.vue?vue&type=template&id=5916e4c2&scoped=true"
import script from "./fiche-de-presence.vue?vue&type=script&setup=true&lang=js"
export * from "./fiche-de-presence.vue?vue&type=script&setup=true&lang=js"
import style0 from "./fiche-de-presence.vue?vue&type=style&index=0&id=5916e4c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5916e4c2",
  null
  
)

export default component.exports